import React, { useEffect, useState } from "react";
import "./panel.scss";
import SiteTexts from "utils/Texts";
import RegionCard from "components/RegionCard/RegionCard";

interface Props {
  regionlist: any;
  reSort: () => void;
  showData: boolean;
}

const RegionSortPage: React.FC<Props> = ({ regionlist, reSort, showData }) => {
  const [data, setData] = useState<any>([]);
  const SiteText = SiteTexts();

  useEffect(() => {
    setData(regionlist);
  }, [regionlist]);

  return (
    <div className="region-sort-main-parent">
      <h4>{SiteText.REGION_SORT.TITLE}</h4>
      <div className="cards-container">
        {showData ? (
          data.map((item: any, key: any) => (
            <RegionCard
              key={key}
              id={item.id}
              title={item.title}
              keyNumber={key}
              maxInput={regionlist.length}
              data={data}
              reSort={reSort}
            />
          ))
        )
         : (
          <div style={{minHeight:'1000px',backgroundColor:'#fff',width:'100%'}}></div>
        )}
      </div>
    </div>
  );
};

export default RegionSortPage;
